import React, {memo} from 'react'
import { strings } from '../../../strings/strings'

export const TravelEndDateDescription = memo(() => {

    return (
        <>
            <p><span className='tooltip-important-text'>{strings.travel.forms.endDateDesc1}</span></p>
            <p>
                <span>{strings.travel.forms.endDateDesc2}</span>
            </p>
        </>
    )
})